import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';

export interface ApiKeyInfo {
  id: string;
  name: string;
  key_prefix: string;
  scopes: string[];
  last_used_at: string | null;
  expires_at: string | null;
  created_at: string;
}

export interface CreateApiKeyResponse extends ApiKeyInfo {
  key: string; // Raw key — shown only once
}

export function useApiKeys() {
  return useQuery<ApiKeyInfo[]>({
    queryKey: ['api-keys'],
    queryFn: async () => {
      const res = await api.get('/auth/api-keys');
      return res.data;
    },
  });
}

export function useCreateApiKey() {
  const qc = useQueryClient();
  return useMutation<CreateApiKeyResponse, Error, { name: string; scopes?: string[] }>({
    mutationFn: async (body) => {
      const res = await api.post('/auth/api-keys', body);
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
}

export function useRevokeApiKey() {
  const qc = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: async (id) => {
      await api.delete(`/auth/api-keys/${id}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
}
